import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { WebhelpETSData } from './webhelp-ets.model';

@Injectable({
	providedIn: 'root'
})
export class WebhelpETSService {

	constructor(
		private cvApiService: CVApiService
		) { }

	public async getWebhelpETSData(moduleKey: string, isAutoRefresh: boolean = false, isFirstLoad: boolean = false) {
		try {
            let renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            let url = `/api/v2/dashboards/modules/webhelp/${encodeURIComponent(moduleKey)}?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`;
            let response = await this.cvApiService.get<WebhelpETSData[]>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (err) {
            console.error("Failed getting data for ets custom module");
            throw err;
        }
	}

    /** Get data from API endpoint for login/logout data formatted for export */
    public async getDataForExport(moduleKey: string, format: string, sort: string){
        try {
            let renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            let url = `/api/v2/dashboards/modules/webhelp/${encodeURIComponent(moduleKey)}/export?format=${encodeURIComponent(format)}&sort=${sort}`;
            let response = await this.cvApiService.get<string[]>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        } catch (err) {
            console.error("Failed getting data to export webhelp module");
            throw err;
        }
    }

    /* Get distinct values for ETS_KEY, used for the Columns selector */
    public async getDistinctETSColumns(moduleKey: string) {
        try {
            let renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            let url = `/api/v2/dashboards/modules/webhelp/columns/${encodeURIComponent(moduleKey)}`;
            let response = await this.cvApiService.get<string[]>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        } catch (err) {
            console.error("Failed getting distinct ETS columns");
            throw err;
        }
    }
}
